import React, { Component } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AC_SETTING_ROOMTYPE_HANDLE_CHANGE, AC_LIST_SETTING_ROOMTYPE, AC_RESET_SETTING_ROOMTYPE, AC_VIEW_SETTING_ROOMTYPE } from '../../actions/settingRoomtypeAction';
import { Link, Redirect } from 'react-router-dom';
import jsPDF from 'jspdf';
import { AC_LIST_HOTEL } from '../../actions/hotelAction';
import ListRoomtype from '../SettingRoomtypeComponents/listroomtypetab';
import ListRoom from '../SettingRoomtypeComponents/listroomtab';
import Outofservice from '../SettingRoomtypeComponents/outofservicetab';

const initialState = {
    modalType: "Add",

    defaultColumDef: {
        // "width": 200,
        // "filter": true,
        // "sortable": true,
        // "resizable": true

        editable: false,
        sortable: true,
        resizable: true,
        filter: true,
        flex: 1,
        minWidth: 100,
    },
    nameError: false,
    searchhoteloption: '',
    searchhotel: '',
    id: '',
    hotelName: '',
}
class ListSettingRoom extends Component {
    constructor(props) {
        super(props);
        this.state = initialState
    }


    onChange = e => {
        const { name, value } = e.target;
        const Error = name + "Error";
        this.setState({ [Error]: false });
        this.props.HandleInputChange(name, value);
    }

    componentDidMount() {
        this.props.ListHotel();
        this.props.AC_LIST_SETTING_ROOMTYPE();
        const account = this.props.AccountState.account;
        this.setState({ hotelName: account.hotelName ? account.hotelName : '' });
    }
    onGridReady = (params) => {
        this.gridColumnApi = params.columnApi;
        this.gridApi = params.api;
        this.gridApi.sizeColumnsToFit();
    }

    exportToCSV = () => {
        const account = this.props.AccountState.account;
        this.gridApi.exportDataAsCsv({
            columnKeys: ['hotel', 'floor', 'room', 'roomtype'],
            fileName: 'rooms' + "_" + (this.state.hotelName && (this.state.hotelName).replace(/ /g, '_')) + (account.currentTime).replace(/ /g, '_') + ".csv",
            processCellCallback: function (params) {
                return params.value;
            }
        })
    }

    exportPDF = () => {
        const account = this.props.AccountState.account;
        const { fixNavbar, RoomState, AccountState } = this.props;
        const exportData = RoomState.listrooms;
        const unit = "pt";
        const size = "A4";
        const orientation = "landscape";
        const marginLeft = 15;
        var img = new Image();
        img.src = '../../assets/images/logo.png';
        const doc = new jsPDF(orientation, unit, size);
        doc.setFontSize(15);
        const title = (this.state.hotelName) ? (this.state.hotelName != "All" ? this.state.hotelName + " - Room List" : "Room List") : "Room List";
        if (this.state.hotelName) {
            var headers = [['#', "Floor", "Room #", "Room Type"]];
            var data = exportData.map((elt, i) => [
                i + 1,
                elt.floor,
                elt.room,
                elt.roomtype,
            ]);
        }
        else {
            var headers = [['#', 'Hotel', "Floor", "Room #.", "Room Type"]];
            var data = exportData.map((elt, i) => [
                i + 1,
                elt.hotel,
                elt.floor,
                elt.room,
                elt.roomtype,
            ]);
        }

        let content = {
            startY: 70,
            head: headers,
            headStyles: { fillColor: [215, 234, 255], textColor: [28, 48, 120], },
            body: data,
            styles: {
                minCellHeight: 30,
                valign: 'middle',
                lineWidth: 0.5,
            },
            margin: {
                left: 10,
                right: 10,
                bottom: 70,
            },
            autoPaging: "text",
        };
        doc.addImage(img, 'png', 780, 6, 50, 50);
        doc.setTextColor(28, 48, 120);
        doc.text(title, marginLeft, 40);
        doc.setTextColor(28, 48, 120);
        // doc.text('MyHotel AI', 710, 40)
        doc.autoTable(content);
        var totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            if (this.state.hotelName) {
                doc.setFontSize(11);
                doc.setTextColor(110);
                doc.text(account.hotelNameExport, 20, 545);
                doc.setFontSize(11);
                doc.setTextColor(110);
                doc.text(account.hoteladdressExport, 20, 560);
            }
            doc.setPage(i);
            doc.setFontSize(11);
            doc.setTextColor(110);
            doc.text('Page ' + i + ' of ' + totalPages, doc.internal.pageSize.getWidth() - 100, doc.internal.pageSize.getHeight() - 20);
            doc.setFontSize(11);
            const fullText = 'This is an auto-generated report from MyHotel AI (www.myhotelai.com)';
            const coloredText = '(www.myhotelai.com)';
            const textColor = [28, 48, 120]; // Specify your desired text color as an RGB array

            const textXPosition = 20;
            const textYPosition = 575;

            // Calculate the width of the full text before the colored text
            const fullTextWidth = doc.getTextWidth(fullText);
            const coloredTextWidth = doc.getTextWidth(coloredText);
            const leadingText = fullText.slice(0, fullText.indexOf(coloredText));

            // Render the leading text with default color
            doc.setTextColor(110); // Set default text color
            doc.text(leadingText, textXPosition, textYPosition);

            // Render the colored text with the specified color
            doc.setTextColor(textColor[0], textColor[1], textColor[2]);
            doc.text(coloredText, textXPosition + fullTextWidth - coloredTextWidth, textYPosition);
        }
        doc.save("rooms" + "_" + (this.state.hotelName && (this.state.hotelName).replace(/ /g, '_')) + (account.currentTime).replace(/ /g, '_') + ".pdf")
    }

    searchUser = e => {
        const { name, value, label } = e;
        this.props.AC_LIST_SETTING_ROOMTYPE({ hotel: value });
        this.setState({ searchhoteloption: e, searchhotel: value, hotelName: label })
    }
    onChangeTab = (e) => {
        this.props.HandleInputChange('tabposition', e);
    }
    render() {
        if (this.state.modalType === "View") return <Redirect to={'view-room/' + this.state.id} />
        if (this.state.modalType === "Edit") return <Redirect to={'edit-room/' + this.state.id} />

        const { SettingRoomtypeState, AccountState, HotelState } = this.props;
        const tabposition = SettingRoomtypeState.room.tabposition;
        const languageData = AccountState.account.SelectedlanguageData
        return (
            <>
                <div className="breadcrump">
                    <p> <Link to="/"><h6>{languageData && languageData.DASHBOARD ? languageData.DASHBOARD : "Dashboard"}</h6></Link>  <span><i className="fa fa-angle-right" aria-hidden="true"></i> </span>  <h6 className="highlights_breadcrump">{tabposition == 'roomtype' ? ((languageData && languageData.ROOM_TYPE_SETTINGS) ? languageData.ROOM_TYPE_SETTINGS + " List" : "Room Type List") : tabposition == 'rooms' ? ((languageData && languageData.ROOM_SETTINGS) ? languageData.ROOM_SETTINGS + " List" : "Room List") : tabposition == 'service' ? ((languageData && languageData.OUT_OF_SERVICE_SETTINGS) ? languageData.OUT_OF_SERVICE_SETTINGS + " List" : "Out Of Service List") : tabposition == 'enquiry' ? "ROOM TYPE ENQUIRY" : ""}</h6></p>
                </div>
                <div className="section-body pt-3">
                    <div className="container-fluid">
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className='card-body dashboard_mom'>
                                        <div className='upcommcomp_btn'>
                                            <div className='mr-2' style={{ position: 'relative' }}>
                                                <button type='button' className={`${tabposition == 'roomtype' ? 'btn btn-primery after_click ' : 'btn btn-primery before_click'}`} onClick={() => this.onChangeTab('roomtype')} >{((languageData && languageData.ROOM_TYPE_SETTINGS) ? languageData.ROOM_TYPE_SETTINGS : "Room Type")}</button><span className="badge badge-light" style={{ backgroundColor: '#17a2b8' }}></span>
                                            </div>
                                            <div className='mr-2' style={{ position: 'relative' }}>
                                                <button type='button' className={`${tabposition == 'rooms' ? 'btn btn-primery after_click ' : 'btn btn-primery before_click'}`} onClick={() => this.onChangeTab('rooms')} >{((languageData && languageData.ROOM_SETTINGS) ? languageData.ROOM_SETTINGS : "Room")}</button><span className="badge badge-light" style={{ backgroundColor: 'red' }}></span>
                                            </div>
                                            <div className='mr-2' style={{ position: 'relative' }}>
                                                <button type='button' className={`${tabposition == 'service' ? 'btn btn-primery after_click ' : 'btn btn-primery before_click'}`} onClick={() => this.onChangeTab('service')} >{((languageData && languageData.OUT_OF_SERVICE_SETTINGS) ? languageData.OUT_OF_SERVICE_SETTINGS : "Out Of Service")}</button><span className="badge badge-light" style={{ backgroundColor: 'green' }}></span>
                                            </div>
                                        </div>
                                    </div>
                                    {tabposition == 'roomtype' ?
                                        <div>
                                            <ListRoomtype historyPush={this.props.history} {...this.props} />
                                        </div>
                                        : ''}
                                    {tabposition == 'rooms' ?
                                        <div>
                                            <ListRoom historyPush={this.props.history} {...this.props} />
                                        </div>
                                        : ''}
                                    {tabposition == 'service' ?
                                        <div>
                                            <Outofservice   {...this.props} />
                                        </div>
                                        : ''}
                                </div>
                            </div>
                        </div >
                    </div >
                </div >
            </>
        )
    }
}
const mapStateToProps = state => ({
    SettingRoomtypeState: state.settingroomtype,
    HotelState: state.hotel,
    AccountState: state.account,

})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        HandleInputChange: AC_SETTING_ROOMTYPE_HANDLE_CHANGE,
        AC_LIST_SETTING_ROOMTYPE,
        ViewRoom: AC_VIEW_SETTING_ROOMTYPE,
        ResetRoom: AC_RESET_SETTING_ROOMTYPE,
        ListHotel: AC_LIST_HOTEL,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ListSettingRoom);